import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

// function rand() {
//   return Math.round(Math.random() * 20) - 10;
// }

function getModalStyle() {
  // const top = 50 + rand();
  // const left = 50 + rand();
  // return {
  //   top: `${top}%`,
  //   left: `${left}%`,
  //   transform: `translate(-${top}%, -${left}%)`,
  // };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "fixed",
    width: 230,
    height: 120,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "auto",
    // backgroundColor: theme.palette.background.paper,
    backgroundColor: "#fff",
    border: "1px solid #656565",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 0,
  },
}));

const AleartModal = (props) => {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  //   下記を呼び出し元で記述
  //   const [open, setOpen] = useState(false);
  //   const handleOpen = () => {
  //     setOpen(true);
  //   };
  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2 className="aleart-title yu-gothic center">{props.title}</h2>
      <div className="spacer-box--sss" />
      <p className="aleart-text yu-gothic center">{props.text}</p>
      <div className="spacer-box--s" />
      <div className="center">
        <div className="aleart-btn-style back-lightGrey" onClick={() => props.handleClose()}>
          OK
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
};

export default AleartModal;
